export enum SiteCodes {
  INTHRACTION = "INTHRACTION",
  DEALHRSHIP = "DEALHRSHIP",
  INSTALLHR = "INSTALLHR"
}
